import styled from "styled-components";
import InputWithLabel from "shared/components/InputWithLabel";
import { hw } from "features/homework/homeworkUi";

interface NormalInputsProps {
    studentInputs: {
        tel: string;
        email: string;
        address: string;
        address_detail: string;
    };
    onChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
}

const NormalInputs = ({ studentInputs, onChange }: NormalInputsProps) => {
    return (
        <Container>
            <Title>연락처·주소</Title>
            <Inputs>
                <InputWithLabel label="전화번호" name="tel" value={studentInputs.tel} onChange={onChange} />
                <InputWithLabel label="이메일" name="email" value={studentInputs.email} onChange={onChange} />
                <Wide>
                    <InputWithLabel label="주소" name="address" value={studentInputs.address} onChange={onChange} />
                </Wide>
                <Wide>
                    <InputWithLabel label="상세 주소" name="address_detail" value={studentInputs.address_detail} onChange={onChange} />
                </Wide>
            </Inputs>
        </Container>
    );
};

const Container = styled.div`
    display: flex;
    flex-direction: column;
    gap: 16px;
    background: ${hw.bg};
    padding: 20px 22px;
    border-radius: 14px;
    border: 1px solid ${hw.border};
`;

const Title = styled.h2`
    margin: 0;
    color: ${hw.text};
    font-size: 16px;
    font-weight: 700;
    letter-spacing: -0.02em;
`;

const Inputs = styled.div`
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 16px 20px;

    @media (max-width: 800px) {
        grid-template-columns: 1fr;
    }
`;

const Wide = styled.div`
    grid-column: 1 / -1;
`;

export default NormalInputs;
